export default function Tab({ tabData, field, setField }) {
  return (
    <div className="flex w-full rounded-lg border border-richblack-700 bg-richblack-900 p-1 gap-1">
      {tabData.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => setField(tab.type)}
          className={`flex-1 rounded-md py-2.5 text-sm font-semibold transition-all duration-200 ${
            field === tab.type
              ? "bg-yellow-50 text-richblack-900 shadow-sm"
              : "bg-transparent text-richblack-400 hover:text-richblack-100"
          }`}
        >
          {tab.tabName}
        </button>
      ))}
    </div>
  );
}
